export default __webpack_public_path__ + "static/media/waterfalls.ec264b00.webp";